export const messages = {
  EMPTY_FIELD: "Este campo é obrigatório.",
  INVALID_EMAIL: "E-mail inválido.",
  INVALID_CPF: "CPF inválido.",
  INVALID_CNPJ: "CNPJ inválido.",
  INVALID_PHONE: "Telefone inválido.",
  INVALID_FIELD: "Campo inválido.",
  REPEAT_EMAIL: "Os e-mails informados devem ser iguais.",
  MIN_VALUE: "Valor abaixo do mínimo",
  MAX_VALUE: "Valor acima do máximo",
  NUMBER_ADDRESS: "Somente números aceitos ou caso não tenha, digite: S/N",
  ONLY_NUMBER: "Somente números aceitos",
  AT_LEAST_ONE_LOWERCASE: "Deve ter pelo menos uma letra minúscula",
  AT_LEAST_ONE_UPPERCASE: "Deve ter pelo menos uma letra maiúscula",
  AT_LEAST_ONE_NUMBER: "Deve ter pelo menos um número",
  AT_LEAST_ONE_SPECIAL_CHAR: "Deve ter pelo menos um carácter especial",
  MIN_LENGTH: "Deve ter no mínimo %% carácter(es)",
  MAX_LENGTH: "Deve ter no máximo %% carácter(es)",
  INVALID_CEP: "CEP inválido.",
  INVALID_SCHEDULE: "Horário inválido.",
  INVALID_DATE: "Data inválida",
  MIN_DATE: "Data inferior a Hoje",
  MIN_ARRAY_LENGTH: "Deve conter pelo menos %% item(s)",
};
